import { render, staticRenderFns } from "./adminDashBoardSideMenu.vue?vue&type=template&id=8e1f7126&scoped=true&"
import script from "./adminDashBoardSideMenu.vue?vue&type=script&lang=js&"
export * from "./adminDashBoardSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1f7126",
  null
  
)

export default component.exports